import { Accordion, Container, Divider } from '@cleartrip/ct-design-components'
import React, { useState } from 'react'

import { getFilterAccordionStyleConfig } from './accordionStyleConfig'
import FilterAccordion from './FilterAccordion'

type FilterCategoryProps = {
  title: string
  count?: number
  onClear: () => void
  isRevamp?: boolean
  clearText?: string
  children: React.ReactNode
}

/** Revamp card header vs legacy ct-design Accordion — one place for both. */
const FilterCategory = ({
  title,
  count,
  onClear,
  isRevamp = false,
  clearText = 'Clear',
  children,
}: FilterCategoryProps) => {
  const [isOpen, setIsOpen] = useState(true)

  if (isRevamp) {
    return (
      <FilterAccordion clearText={clearText} count={count} title={title} onClearClick={onClear}>
        {children}
      </FilterAccordion>
    )
  }

  return (
    <Accordion
      disableTransition
      title={title}
      isOpen={isOpen}
      showBorders={false}
      clearText={clearText}
      onClearTextClick={(e: any) => {
        e.stopPropagation()
        onClear()
      }}
      onClick={() => setIsOpen(open => !open)}
      styleConfig={getFilterAccordionStyleConfig('pt-4')}
    >
      {children}
    </Accordion>
  )
}

export const FilterLegs = ({ isRevamp, children }: { isRevamp?: boolean; children: React.ReactNode }) => (
  <Container className={isRevamp ? 'flex flex-column flex-rg-3' : undefined}>{children}</Container>
)

export const RevampRtDivider = ({ show }: { show: boolean }) =>
  show ? <Divider borderStyle='dashed' className='bc-line-500' /> : null

export default FilterCategory
